import {
  ORDERS_SELL_REPORT_FAILED,
  ORDERS_SELL_REPORT_SUCCESS,
  ORDERS_SELL_REPORT_INVALID_REQUEST,
  ORDERS_SELL_REPORT_NOT_FOUND,
  LOADING_ORDERS_SELL_REPORT,
  RESET_ORDERS_SELL_REPORT,
  DELETE_VP_SUCCESS,
} from "../types";

const initialState = {
  isLoading: false,
  success: false,
  failed: false,
  invalidRequest: false,
  notFound: false,
  reports: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_ORDERS_SELL_REPORT:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        invalidRequest: false,
        notFound: false,
      };

    case ORDERS_SELL_REPORT_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        invalidRequest: false,
        notFound: false,
      };

    case ORDERS_SELL_REPORT_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: true,
        failed: false,
        notFound: false,
      };

    case ORDERS_SELL_REPORT_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        success: true,
        invalidRequest: false,
        failed: false,
        notFound: false,
        reports: action.payload,
      };
    }

    case ORDERS_SELL_REPORT_NOT_FOUND:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        failed: false,
        notFound: true,
      };

    case RESET_ORDERS_SELL_REPORT:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        failed: false,
        notFound: false,
      };

    default:
      return state;
  }
};
